export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_07_end.a6373e4d.jpg";